module.exports = __webpack_public_path__ + "media/evolve/assets/icons/fontawesome/solid/envelope-39c094f9f51fb898078a09cdea6e05b4.svg";